import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data from '../../data/data25.json';
import ArticleList from '../../Components/ArticleList';

const Honors: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>荣誉认证</h1>
                <ArticleList dataId="25" data={data as any} />
            </div>
        } />
    );
};

export default Honors;